import { render } from "./FormWithCalculator.vue?vue&type=template&id=9b04effc&scoped=true"
import script from "./FormWithCalculator.vue?vue&type=script&lang=js"
export * from "./FormWithCalculator.vue?vue&type=script&lang=js"

import "./FormWithCalculator.vue?vue&type=style&index=0&id=9b04effc&lang=css"
import "./FormWithCalculator.vue?vue&type=style&index=1&id=9b04effc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b04effc"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QField,QSelect,QSpinner,QCheckbox,QInput});
